<template>
  <v-content class="create campaign page">
    <can I="create" a="Campaign">
      <v-container>
        <v-toolbar flat class="transparent">
          <v-breadcrumbs class="pl-0"
            :items="[
              { exact: true, text: 'Admin', to: '/dashboard' },
              { exact: true, text: 'Campaigns', to: '/campaigns' },
              { exact: true, text: 'New', to: '/campaigns/new' },
            ]">
            <v-icon slot="divider">mdi-chevron-right</v-icon>
          </v-breadcrumbs>
        </v-toolbar>

        <v-card dark>
          <v-card-title primary-title class="headline">Create a new campaign</v-card-title>

          <v-card-text>
            <v-form @submit.prevent="submit" v-model="valid">
              <v-text-field
                v-model="campaign.slug"
                label="Slug"
                required
                counter="32"
                :rules="rules.slug"
                :error-messages="campaign.errors.slug || []"
             />
              <v-select
                v-model="campaign.campaignableType"
                label="Type"
                required
                :items="['Organization', 'Opportunity']"
              />
              <v-select
                v-if="campaign.campaignableType === 'Organization' && organizations.length > 0"
                v-model="campaign.campaignableId"
                label="Organization"
                :items="organizations"
                item-text="name" item-value="id"
                required
              />
     
                <OpportunitySelect clearable
                  v-if="campaign.campaignableType === 'Opportunity'"
                  v-model="campaign.campaignableId"
                  required
                />
            </v-form>
          </v-card-text>

          <v-card-actions><v-spacer />
            <v-btn flat to="/campaigns" color="grey">
              Cancel
            </v-btn>
            <v-btn color="primary" :disabled="!valid" @click="submit">
              Create Campaign
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </can>
  </v-content>
</template>

<script>
// Component
import OpportunitySelect from '@/components/selects/OpportunitySelect'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  components: { OpportunitySelect },
  created() {
    this.$store.dispatch('organizations/fetchAll')
  },
  data() {
    return {
      // Model
      campaign: {
        slug: '',
        campaignableId: null,
        campaignableType: 'Organization',
        errors: {},
      },
      // Validations
      valid: false,
      rules: {
        slug: [v => !!v || 'must be provided'],
      },
    }
  },
  computed: mapGetters({
    organizations: 'organizations/all',
  }),
  methods: {
    submit() {
      this.$store
        .dispatch('admin/campaigns/create', this.campaign)
        .then(response => this.$router.push(`/campaigns/${response.id}`))
        .catch(() =>
          this.$store.commit('snackbar', {
            text: 'There was a problem creating the campaign',
            type: 'error',
          })
        )
    },
  },
}
</script>
